var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useReducer } from 'react';
import { FormControlLabel, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { Box, Button, Checkbox, Paper, TextField, Typography, } from '@kareo/design-system';
import { validateCardholderName } from 'shared-assets/patient-intake-ui/scenes/CreditCardAuth/validateUtil';
import validateZipcode from '../validateZipcode';
function getHelperTextDefault(_a) {
    var errorText = _a.errorText, showError = _a.showError, value = _a.value;
    if (!showError) {
        return undefined;
    }
    if (value.length === 0) {
        return 'Required';
    }
    return errorText;
}
var StyledTextField = styled(TextField)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && input.MuiInputBase-input {\n    border: 0;\n    box-shadow: none;\n    margin: 0;\n    padding-bottom: 10.5px;\n    padding-top: 10.5px;\n  }\n\n  && input.MuiInputBase-input:focus {\n    box-shadow: none;\n  }\n\n  && fieldset.MuiOutlinedInput-notchedOutline {\n    border-style: solid;\n    border-width: 1px;\n    margin: 0;\n    padding: 0 8px;\n  }\n"], ["\n  && input.MuiInputBase-input {\n    border: 0;\n    box-shadow: none;\n    margin: 0;\n    padding-bottom: 10.5px;\n    padding-top: 10.5px;\n  }\n\n  && input.MuiInputBase-input:focus {\n    box-shadow: none;\n  }\n\n  && fieldset.MuiOutlinedInput-notchedOutline {\n    border-style: solid;\n    border-width: 1px;\n    margin: 0;\n    padding: 0 8px;\n  }\n"])));
export function FormTextField(props) {
    return React.createElement(StyledTextField, __assign({ fullWidth: true, size: "small", margin: "none" }, props));
}
export default function NewCardForm(props) {
    var _a, _b;
    var formState = props.formState, setFormState = props.setFormState, _c = props.onSubmit, onSubmit = _c === void 0 ? function () { } : _c, _d = props.getHelperText, getHelperText = _d === void 0 ? getHelperTextDefault : _d, _e = props.config, config = _e === void 0 ? {
        showComments: true,
        showNickname: true,
    } : _e, onCancel = props.onCancel, patientAddress = props.patientAddress;
    // this state determines if we are showing errors, not what the errors are
    var _f = useReducer(function (state, changes) {
        return __assign(__assign({}, state), changes);
    }, {
        showNameError: false,
        showZipError: false,
    }), errors = _f[0], setErrors = _f[1];
    var hasValidForm = validateCardholderName(formState.cardholderName) &&
        validateZipcode(formState.zipCode);
    var commentsLength = (_b = (_a = formState.comments) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    function onSubmitBaseForm(evt) {
        evt.preventDefault();
        if (!hasValidForm)
            return;
        onSubmit(formState);
    }
    function onChangeForm(evt) {
        var _a;
        var _b = evt.target, checked = _b.checked, name = _b.name, type = _b.type, value = _b.value;
        setFormState(__assign(__assign({}, formState), (_a = {}, _a[name] = type === 'checkbox' ? checked : value, _a)));
    }
    function onUsePatientAddressChange(evt) {
        var _a, _b;
        var checked = evt.target.checked;
        setFormState(__assign(__assign({}, formState), { billingAddress1: checked ? (_a = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.address1) !== null && _a !== void 0 ? _a : '' : '', usePatientAddress: checked, zipCode: checked ? (_b = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode) !== null && _b !== void 0 ? _b : '' : '' }));
    }
    return (React.createElement(Paper, { variant: "outlined" },
        React.createElement(Box, { padding: 2 },
            React.createElement(Box, { component: "form", onSubmit: onSubmitBaseForm },
                React.createElement(Box, { marginBottom: 2 },
                    React.createElement(Typography, { variant: "h4" }, "Add a Card")),
                React.createElement(Grid, { container: true, spacing: 1 },
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "cardholder-name", name: "cardholderName", value: formState.cardholderName, label: "Cardholder Name", placeholder: "Enter cardholder name", autoComplete: "cc-name", error: errors.showNameError, helperText: getHelperText({
                                errorText: 'Invalid Characters',
                                showError: errors.showNameError,
                                value: formState.cardholderName,
                            }), onChange: onChangeForm, onBlur: function () {
                                setErrors({
                                    showNameError: !validateCardholderName(formState.cardholderName),
                                });
                            } })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "billing-zip-code", name: "zipCode", value: formState.zipCode, label: "Billing Zip Code", disabled: formState.usePatientAddress, error: errors.showZipError, helperText: getHelperText({
                                errorText: 'Invalid',
                                showError: errors.showZipError,
                                value: formState.zipCode,
                            }), onChange: onChangeForm, onBlur: function () {
                                setErrors({
                                    showZipError: !validateZipcode(formState.zipCode),
                                });
                            } })),
                    config.showUsePatientAddress && (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: Boolean(formState.usePatientAddress), disabled: !(patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode), onChange: onUsePatientAddressChange }), label: "Use patient's address as billing address" }))),
                    config.showNickname && (React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "card-nickname", name: "nickname", value: formState.nickname, label: "Card Nickname (optional)", onChange: onChangeForm }))),
                    config.showComments && (React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormTextField, { id: "practice-comments", name: "comments", value: formState.comments, label: "Comments for the practice", helperText: commentsLength + "/60", FormHelperTextProps: {
                                style: {
                                    marginLeft: 0,
                                    marginRight: 0,
                                    textAlign: 'right',
                                },
                            }, inputProps: { maxLength: 60 }, onChange: onChangeForm })))),
                React.createElement(Box, { display: "flex", flexDirection: "row", justifyContent: "flex-end" },
                    onCancel && (React.createElement(Box, { marginRight: 1 },
                        React.createElement(Button, { type: "button", variant: "text", onClick: onCancel }, "Cancel"))),
                    React.createElement(Box, null,
                        React.createElement(Button, { type: "submit", disabled: !hasValidForm, variant: "contained", color: "default" }, "Add Card Number")))))));
}
var templateObject_1;
